import { documentStagingList, documentStagingInfo } from '@/assets/request/EnquiryRecord.js'
import { Message } from 'element-ui'
export default {
  state:{
    list: [],
    page: 1,
    page_size: 10,
    totalNum: 0,
    totalPage: 0,
    stagingData:{},
  },
  mutations: {
    orderRecordStagingChange(state,obj){
      Object.entries(obj).forEach(item=>{
        state[ item[0] ] = item[1]
      })
    },
  },
  actions: {
    orderDocumentStagingList({ state,commit }, { type_id, vin, plate_no, }){
      documentStagingList({
        type_id,
        vin,
        plate_no,
        page: state.page,
        page_size: state.page_size,
      }).then(r=>{
        const { data: res } = r
        if(res.code!==200) return Message.warning(res.msg)
        const { list, page_num: totalPage, total:totalNum, } = res.data
        commit('orderRecordStagingChange',{
          list: list.map(i=>({
            ...i,
            data: JSON.parse(i.data)
          })),
          totalPage,
          totalNum
        })
      })
    },
    orderDocumentStagingInfo({ commit }, { id }){
      documentStagingInfo({id}).then(r=>{
        const { data:res } = r
        if(res.code!==200) {
          commit('orderRecordStagingChange',{
            stagingData:{},
          })
          return Message.warning(res.msg)
        }
        res.data.data = JSON.parse(res.data.data)
        commit('orderRecordStagingChange',{
          stagingData: res.data,
        })
        commit('changeTab',{
          componentName: 'orderStagingDetail',
        })
      })
    },
  },
  getters: {
    orderRecord: state => state,
  },
}